
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home/events/[adSlug]",
      function () {
        return require("private-next-pages/home/events/[adSlug].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home/events/[adSlug]"])
      });
    }
  